# Singleton store for our app

makeStore = require 'state/makeStore'

store = makeStore()

module.exports = store



// WEBPACK FOOTER //
// ./state/store.coffee